import { Color } from "../../defines/colors"
import { Symbol } from "../../defines/symbols"
import { Position } from "../../defines/types"
import { Entity } from "../entity"

export class Residue extends Entity {
  constructor(position: Position, name: string) {
    super(
      position,
      false,
      {
        symbol: [Symbol.RESIDUE],
        light: Color.RESIDUE,
        dark: Color.RESIDUE_DARK,
      },
      "residue of " + name
    )
  }
}
